export default __webpack_public_path__ + "static/char-s-08-chs-0e53c9d850b25e648d528c5263c1ebba.png";